import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function changePassword(body: any, userId: any) {
  const payload = {
    id: userId,
    password: body.password.value,
    old_password: body.old_password.value,
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.CHANGEPASSWORD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
